import { breadcrumbs } from 'shared/common/AppBreadcrumb/model/constants'

import { ReactElement } from 'react'

import { Link } from 'react-router-dom'

const getPathUrl = (pathSnippets: string[], index: number) =>
  `/${pathSnippets.slice(0, index + 1).join('/')}/`

const getBreadCrumbItems = (
  pathname: string,
  locationState?: { [k: string]: string },
  searchParams?: Record<string, string>,
  params?: { [k: string]: string | undefined },
) => {
  const paramsKeys = Object.keys(params as object).filter(
    (param) => param !== '*',
  )
  const pathSnippets = pathname.split('/').filter((i) => i)

  const items: { key: string; title: ReactElement }[] = []

  pathSnippets.forEach((segment, index) => {
    const url = getPathUrl(pathSnippets, index)
    if (url === '/dashboard/') return
    const linkText =
      breadcrumbs[segment] ||
      locationState?.[`${paramsKeys.shift()}${segment}`] ||
      '-'

    const search = searchParams?.[url] || ''
    items.push({
      key: url,
      title: <Link to={{ pathname: url, search }}>{linkText}</Link>,
    })
  })

  return items
}

export { getBreadCrumbItems }
